export enum ConsultantLoginTypeEnum {
    Intranet = 'Intranet',
    MyCustomers = 'MyCustomers',
}
